<template>
  <FieldWrapper
    :state="state"
    :configs="configs"
  >
    <template #after>
      <div class="column full-width q-mt-md">
        <q-btn
          dense
          outline
          color="primary"
          no-caps
          padding="6px 6px"
          :icon="icon"
          size="11px"
          :label="configs.buttonLabel"
          :disable="disabled || isRunning"
          :loading="isRunning"
          @click="onClick"
        >
          <template #loading>
            <q-spinner-ios size="14px" />
            <span class="q-ml-xs">Consultando…</span>
          </template>

          <q-menu
            v-if="isApiMode && confirmBeforeRun"
            v-model="showConfirm"
            no-parent-event
            anchor="bottom left"
            self="top left"
          >
            <q-card style="min-width: 220px">
              <q-card-section class="q-pb-none">
                <span class="text-body2">Executar "{{ configs.buttonLabel }}"?</span>
                <div
                  v-for="item in confirmSummary"
                  :key="item.label"
                  class="text-caption"
                >
                  {{ item.label }}: {{ item.value }}
                </div>
              </q-card-section>
              <q-card-actions align="right">
                <q-btn
                  :data-testid="`campo-botao-${buttonHook.id}-cancelar`"
                  flat
                  no-caps
                  dense
                  label="Cancelar"
                  v-close-popup
                />
                <q-btn
                  :data-testid="`campo-botao-${buttonHook.id}-confirmar`"
                  flat
                  no-caps
                  dense
                  color="primary"
                  label="Confirmar"
                  @click="confirmRun"
                />
              </q-card-actions>
            </q-card>
          </q-menu>
        </q-btn>

        <div
          v-if="status === 'success'"
          class="q-mt-xs column field-button__result"
        >
          <div class="row no-wrap items-center">
            <q-icon
              name="mdi-check-circle"
              size="14px"
              style="color: #16A34A"
              class="q-mr-xs col-auto"
            />
            <span>Executado · {{ timeLabel }}</span>
          </div>
          <div
            v-for="(item, index) in display"
            :key="index"
          >
            {{ item.label }}: {{ formatValue(item.value) }}
          </div>
        </div>

        <div
          v-if="status === 'error'"
          class="q-mt-xs field-button__result"
          style="color: #C00F0C"
        >
          <span>Falha na consulta ({{ errorStatus }}) · </span>
          <span
            class="cursor-pointer text-weight-medium"
            style="text-decoration: underline"
            @click="onClick"
          >tentar novamente</span>
        </div>
      </div>
    </template>
  </FieldWrapper>
</template>

<script>
import { mapActions } from 'vuex'
import buttonConfirmSummary from '@/libs/buttonConfirmSummary'
import { buildButtonPayload } from '@/store/modules/attendanceModule'
import FieldWrapper from './FieldWrapper'
const shell = window.shell

export default {
  components: {
    FieldWrapper
  },

  props: {
    state: {},
    configs: {},
    profilerId: {},
    attendanceId: {},

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      showConfirm: false
    }
  },

  computed: {
    result () {
      const { attendanceId, profilerId, buttonHook } = this
      const key = `${attendanceId}:${profilerId}:${buttonHook?.id}`
      return this.$store.state.attendanceModule.buttonResults[key] || {}
    },

    status () {
      return this.result.status || 'idle'
    },

    display () {
      return this.result.display || []
    },

    executedAt () {
      return this.result.executedAt
    },

    errorStatus () {
      return this.result.errorStatus
    },

    confirmSummary () {
      const variables = this.buttonHook?.variables || []
      if (!variables.length) return []
      const { attendanceId, profilerId } = this
      try {
        const payload = buildButtonPayload({ state: this.$store.state.attendanceModule, rootState: this.$store.state }, { attendanceId, profilerId })
        return buttonConfirmSummary(variables, payload)
      } catch (err) {
        return []
      }
    },

    url () {
      return this.configs?.url
    },

    buttonHook () {
      return this.configs?.buttonHook
    },

    isApiMode () {
      return Boolean(this.buttonHook) && this.buttonHook.action === 'api'
    },

    confirmBeforeRun () {
      return this.buttonHook?.confirmBeforeRun === 'yes'
    },

    isRunning () {
      return this.status === 'running'
    },

    icon () {
      if (this.configs?.buttonIcon) return this.configs.buttonIcon
      return this.isApiMode ? 'mdi-flash' : 'mdi-web'
    },

    timeLabel () {
      if (!this.executedAt) return ''
      return new Date(this.executedAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    }
  },

  methods: {
    ...mapActions({
      execButtonHook: 'attendanceModule/execButtonHook'
    }),

    formatValue (value) {
      return value === null || value === undefined ? '—' : value
    },

    onClick () {
      if (!this.isApiMode) return this.openUrl()
      if (this.confirmBeforeRun) {
        this.showConfirm = true
        return
      }
      this.run()
    },

    confirmRun () {
      this.showConfirm = false
      this.run()
    },

    openUrl () {
      shell.openExternal(this.url)
    },

    run () {
      return this.execButtonHook({
        attendanceId: this.attendanceId,
        profilerId: this.profilerId,
        hookId: this.buttonHook.id
      })
    }
  }
}

</script>

<style lang="sass">
.field-button__result
  font-size: 11px
  line-height: 14px
  overflow-wrap: anywhere
  user-select: text
</style>
